import WorkoutSmartDateDetails from '../../components/calendars/WorkoutSmartDateDetails';
import WorkoutEventContent from '../../components/calendars/WorkoutEventContent';
import { updateWorkoutSession } from '../../services/workoutSessionApi';
import { patchBioLog } from '../../services/bioLogsApi'; // Import patchBioLog

export const calendarAppConfig = {
  singleCalendarMode: true,
  dateDetailsComponent: WorkoutSmartDateDetails,
  singleCalendarName: 'My Calendar',
  eventContentComponent: WorkoutEventContent,
  getEventFormSettings: (event) => {
    const isWorkoutSession = event?.references?.some(r =>
        r.parent_type === 'workout_session' || r.child_type === 'workout_session'
    );
    const isBioLog = event?.references?.some(r =>
        r.parent_type === 'bio_log' || r.child_type === 'bio_log'
    );
    
    if (isWorkoutSession || isBioLog) {
        return {
            enableRecurrence: false,
            enableAllDay: false
        };
    }
    return {
        enableRecurrence: true,
        enableAllDay: true
    };
  },
  customDateUpdater: async (originalEvent, newDateData) => {
    if (!originalEvent || !originalEvent.references) return false;
    
    // 1. Handle Workout Sessions
    const sessionRef = originalEvent.references.find(
      r => r.parent_type === 'workout_session' || r.child_type === 'workout_session'
    );

    if (sessionRef && (sessionRef.parent_type === 'workout_session' || sessionRef.child_type === 'workout_session')) {
      const sessionId = sessionRef.parent_type === 'workout_session' ? sessionRef.parent_id : sessionRef.child_id;
      const payload = {
        name: newDateData.title,
        start_time: newDateData.start_datetime instanceof Date ? newDateData.start_datetime.toISOString() : newDateData.start_datetime,
        end_time: newDateData.end_datetime instanceof Date ? newDateData.end_datetime.toISOString() : newDateData.end_datetime
      };
      console.log(`[AppConfig] Intercepted date update for session ${sessionId}. Updating session details.`);
      await updateWorkoutSession(sessionId, payload);
      return true;
    }

    // 2. Handle Bio Logs
    const bioLogRef = originalEvent.references.find(
      r => r.parent_type === 'bio_log' || r.child_type === 'bio_log'
    );

    if (bioLogRef) {
      const bioLogId = bioLogRef.parent_type === 'bio_log' ? bioLogRef.parent_id : bioLogRef.child_id;
      
      const newDate = newDateData.start_datetime instanceof Date 
        ? newDateData.start_datetime.toISOString() 
        : newDateData.start_datetime;

      console.log(`[AppConfig] Intercepted date update for bio_log ${bioLogId}. Patching domain object.`);
      // Use PATCH to avoid overwriting the entire object
      await patchBioLog(bioLogId, { date: newDate });
      return true;
    }
    
    return false;
  }
};